<template>
  <div>
    <report-list v-if="$route.name === 'report-list'"></report-list>
    <router-view v-else></router-view>
  </div>
</template>

<script setup lang="ts">
import ReportList from './ReportList.vue'
</script>

<style scoped></style>
